import {
  createNetworkInterface,
  IntrospectionFragmentMatcher,
} from 'apollo-client';
import bootstrapApollo from 'legacy/src/bootstrap/apollo';

import fragmentMatcher from 'legacy-packages/unit-outline/src/utils/fragmentMatcher';
import introspectionQueryResultData from 'legacy/src/fragmentTypes.json';

const fymFragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

/**
 * Create client
 * @param {object} props Client properties
 * @return Bootstraped apollo client
 * */
const createClient = (props) => {
  const { URI, fragmentMatcher, context, key } = props;
  const endpoint = context === 'wizardClient' ? '/graphql/' : '/graphql';

  const networkInterface = createNetworkInterface({
    uri: `${URI}${endpoint}`,
  });

  return bootstrapApollo(
    networkInterface,
    fragmentMatcher,
    key === 'impersonator-fym',
  );
};

/**
 * Client URI's object list
 * */
export const unitsClient = createClient({
  key: 'units',
  context: 'unitsClient',
  URI: FYM_UNITS_BACKEND_URL,
  fragmentMatcher,
});

export const fymClient = createClient({
  key: 'fym',
  context: 'fymClient',
  URI: FYM_BACKEND_URL,
  fragmentMatcher: fymFragmentMatcher,
});

export const impersonatorFymClient = createClient({
  key: 'impersonator-fym',
  context: 'impersonatorFymClient',
  URI: FYM_BACKEND_URL,
  fragmentMatcher: fymFragmentMatcher,
});

export const reportsClient = createClient({
  key: 'reports',
  context: 'reportsClient',
  URI: FYM_BACKEND_REPORTING_URL,
});

export const wizardsClient = createClient({
  key: 'wizards',
  context: 'wizardClient',
  URI: FYM_WIZARDS_BACKEND_URL,
});
